import { atom } from "jotai";

import {
  currentBookingAtom,
  originalBookingAtom,
  remainingSlotCapacityAtom,
} from "../../stores";

export const canAddAdditionalRoundsAtom = atom<boolean>((get) => {
  const originalBooking = get(originalBookingAtom);
  if (!!originalBooking?.isAlreadyPaid) {
    return false;
  }
  const currentBooking = get(currentBookingAtom);
  if (!currentBooking) {
    return false;
  }

  const isAggregateRequest = currentBooking.rounds.some(
    (round) => round.bookingIndex != null
  );
  const groupCapacity = currentBooking.groupCapacity;
  if (isAggregateRequest && groupCapacity != null) {
    const groupCounts = new Map<number, number>();
    currentBooking.rounds.forEach((round) => {
      const bookingIndex = round.bookingIndex ?? 0;
      groupCounts.set(
        bookingIndex,
        (groupCounts.get(bookingIndex) ?? 0) + (round.isNonPlayingHost ? 0 : 1)
      );
    });

    const groupCount =
      currentBooking.requestGroupCount ??
      Math.max(...Array.from(groupCounts.keys())) + 1;
    return Array.from({ length: groupCount }, (_, bookingIndex) => {
      return (groupCounts.get(bookingIndex) ?? 0) < groupCapacity;
    }).some(Boolean);
  }

  const originalRoundCount = originalBooking?.rounds?.length ?? 0;
  const currentRoundCount = currentBooking?.rounds?.length ?? 0;

  const roundCountDelta = originalRoundCount - currentRoundCount;
  const remainingSlotCapacity = get(remainingSlotCapacityAtom) ?? 0;
  const adjustedRemainingCapacity = remainingSlotCapacity + roundCountDelta;

  return adjustedRemainingCapacity > 0;
});
